export function ensureCaughtErrorIsError(error: unknown): Error {
    if (error instanceof Error) {
        return error;
    } else if (typeof error === 'string') {
        /* eslint-disable-next-line owa-custom-rules/no-error-dynamic-event-names --
         * This is handling the case where a string is thrown and caught by a try-catch. */
        return new Error(error);
    }

    const normalizedError = new Error('Caught non-Error non-string type value');
    normalizedError.message = getThrownMessage(error) ?? normalizedError.message;
    return normalizedError;
}

function getThrownMessage(error: unknown): string | undefined {
    if (typeof error === 'string') {
        return error;
    }

    if (typeof error === 'object' && error !== null && 'message' in error) {
        return typeof error.message === 'string' ? error.message : undefined;
    }

    return undefined;
}
